import React from 'react';
import UploadFilesContent from 'components/upload-sync-files/UploadFilesContent';
import UploadSyncFilesHeader from 'components/upload-sync-files/UploadSyncFilesHeader';
import { NoSidebarLayout } from '@insurancemenu/imenu-components-lib';

const UploadSyncFilesPage: React.FC = () => {
  return (
    <NoSidebarLayout contentWidth="wide">
      <UploadSyncFilesHeader />
      <UploadFilesContent />
    </NoSidebarLayout>
  );
};

export default UploadSyncFilesPage;
